export default __webpack_public_path__ + "static/138-373ca109de4021bf10569776f44d5732.jpg";